module.exports = __webpack_public_path__ + "img/windsurfen--white.f5c34807.svg";